import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './AuthCode.css';

import Counter from '../Counter/Counter';

import planet from '../../../../assets/images/planet.svg';

export default class AuthCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth_code1: '',
      auth_code2: '',
      auth_code3: '',
      auth_code4: '',
      flag: false,
    }
  }

  flagSetter = () => {
    this.setState({
      flag: true,
    })
  }

  changeValue = (name, value) => {
    if (value.match("^[0-9]{1}$") !== null) {
      this.setState({
        [name]: value,
      })
    } else {
      return;
    }
  }

  componentDidMount() {
    this.inputRef1.focus();
  }




  componentDidUpdate() {
    if (this.state.auth_code1) {
      this.inputRef2.focus();
    }
    if (this.state.auth_code2) {
      this.inputRef3.focus();
    }
    if (this.state.auth_code3) {
      this.inputRef4.focus();
    }
  }

  onKeyDown = (e) => {
    if (e.keyCode === 8) {
      this.setState({
        [e.target.name]: '',
      })
    }
  }

  render() {

    return (
      <div className="auth-code d-flex flex-column" >
        <div className="auth-code__back" onClick={() => this.props.back()}>بازگشت</div>
        <div className="auth-code__header topAnimate">
          <img src={planet} />
        </div>
        <div className="auth-code__time fadeAnimation">
          <div>یک کد برای شما پیام کردیم آن را در زیر وارد نمائید </div>
          <div>مدت زمان اعتبار کد <strong><Counter flagSetter={this.flagSetter} /></strong></div>
        </div>
        <div className="auth-code__field d-flex flex-row-reverse fadeAnimation">
          <input
            name="auth_code1"
            onChange={(e) => this.changeValue(e.target.name, e.target.value)}
            maxLength="1"
            ref={(input) => { this.inputRef1 = input }}
            value={this.state.auth_code1}
            onKeyDown={this.onKeyDown}
            autoComplete="false"
          />
          <input
            name="auth_code2"
            onChange={(e) => this.changeValue(e.target.name, e.target.value)}
            value={this.state.auth_code2}
            maxLength="1"
            ref={(input) => { this.inputRef2 = input }}
            onKeyDown={this.onKeyDown}
            autoComplete="false"
          />
          <input
            name="auth_code3"
            onChange={(e) => this.changeValue(e.target.name, e.target.value)}
            maxLength="1"
            ref={(input) => { this.inputRef3 = input }}
            value={this.state.auth_code3}
            onKeyDown={this.onKeyDown}
            autoComplete="false"
          />
          <input
            name="auth_code4"
            onChange={(e) => this.changeValue(e.target.name, e.target.value)}
            maxLength="1"
            ref={(input) => { this.inputRef4 = input }}
            value={this.state.auth_code4}
            onKeyDown={this.onKeyDown}
            autoComplete="false"
          />
        </div>

        <div className="auth-code__submit d-flex mt-4 fadeAnimation">
          <button className='btn btn-primary' type="submit">تایید</button>
        </div>

        <div className="auth-code__resend mt-3 fadeAnimation">{this.state.flag ? "ارسال مجدد کد فعال سازی" : null}</div>
      </div>
    );
  }
}
